import { AuthSessionPayload, AuthUserProfile } from '../types';
import { apiRequest } from './apiClient';
import { setAuthSession } from './authStorage';

interface LoginResponse {
  accessToken: string;
  refreshToken: string;
    user: {
      id: string;
      email: string;
      nome: string;
      nickname?: string;
      nomeCompleto?: string;
      cpf: string;
    };
}

interface ProfileResponse {
  mensagem: string;
  data: AuthUserProfile;
}

export const authService = {
  async login(cpf: string, senha: string): Promise<AuthSessionPayload> {
    const payload = await apiRequest<LoginResponse>('/auth/login', {
      method: 'POST',
      skipAuth: true,
      body: JSON.stringify({ cpf, senha }),
    });

    const session: AuthSessionPayload = {
      accessToken: payload.accessToken,
      refreshToken: payload.refreshToken,
      userId: payload.user.id,
      userEmail: payload.user.email || '',
      userName: payload.user.nickname || payload.user.nome || '',
    };

    setAuthSession(session);
    return session;
  },

  async getProfile(): Promise<AuthUserProfile> {
    const payload = await apiRequest<ProfileResponse>('/auth/profile');
    setAuthSession({
      userId: payload.data.id || '',
      userEmail: payload.data.email || '',
      userName: payload.data.nickname || payload.data.nome || '',
    });
    return payload.data;
  },
};
